<div class="du-chat-dialog">
    <mat-dialog-content>
        <div>
            <h2>Chat</h2>
            <div *ngFor="let msg of messages">
              <strong>{{ msg.user }}:</strong> {{ msg.message }}
            </div>
        </div>     
    </mat-dialog-content>
    <mat-dialog-actions>
        <div style="position: relative;width: 100%;" (click)="$event.stopPropagation()">
            <input 
                id="comment"
                class="du-chat-text"
                type="text" 
                (click)="$event.stopPropagation()" 
                placeholder="Type a message..." 
                [(ngModel)]="message"
                (keydown.enter)="sendMessage()"
            >
                
            <div class="du-chat-send-icon" (click)="sendMessage()">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.74958 10.2501L16.4996 1.50014M7.8559 10.5235L10.046 16.1552C10.2389 16.6513 10.3354 16.8994 10.4744 16.9718C10.5949 17.0346 10.7384 17.0347 10.859 16.972C10.9981 16.8998 11.0949 16.6518 11.2884 16.1559L16.7803 2.08281C16.955 1.63516 17.0424 1.41133 16.9946 1.26831C16.9531 1.1441 16.8556 1.04663 16.7314 1.00514C16.5884 0.957356 16.3646 1.0447 15.9169 1.21939L1.84379 6.71134C1.3479 6.90486 1.09995 7.00163 1.02769 7.14071C0.965054 7.26129 0.965139 7.40483 1.02792 7.52533C1.10034 7.66433 1.3484 7.7608 1.84452 7.95373L7.47619 10.1438C7.5769 10.183 7.62725 10.2026 7.66965 10.2328C7.70724 10.2596 7.7401 10.2925 7.76691 10.3301C7.79715 10.3725 7.81673 10.4228 7.8559 10.5235Z" stroke="#1363DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    </mat-dialog-actions>
</div>